import { render, staticRenderFns } from "./new-good-price-billion.vue?vue&type=template&id=d31a273c&scoped=true"
import script from "./new-good-price-billion.vue?vue&type=script&lang=js"
export * from "./new-good-price-billion.vue?vue&type=script&lang=js"
import style0 from "./new-good-price-billion.vue?vue&type=style&index=0&id=d31a273c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31a273c",
  null
  
)

export default component.exports